// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"video_wrapper__7gXeV","poster":"video_poster__VX4NP","hidden":"video_hidden__NAyj_","player":"video_player__WuHzR","play":"video_play__Zb_cb"};